<!-- 
	WinWinFooter
	props: N/A
  	role: Public
	Called by @/App for a fancy footer with external links
-->

<template>
  <div class="footer text-white text-center sm:text-left">
    <div
      class="
        flex
        w-2/3
		mx-auto
        flex-col
        sm:flex-row
        py-12
        pb-20
      "
    >
      <div class="flex-1 mt-12 sm:mt-0">
        <div class="fancy-font2 winwin-gold bigger-font sm:mb-6">
          QuickLinks
        </div>
        <div class= "rowfooter">
          <div class="columnfooter">
            <div>
              <a
                href="https://winwinstafflottery.ca/faq"
                target="_blank"
              >Got Questions</a>
            </div>
            <div>
              <a
                href="https://winwinstafflottery.ca/rules"
                target="_blank"
              >Rules</a>
            </div>
            <div>
              <a href="https://winwinstafflottery.ca/contact">Contact</a>
            </div>
          </div>
          
          <div class="columnfooter">
            
            <div><a href="/settings/opt-out">Opt Out</a></div>
            <div><a href="/settings/update-tickets">Update Tickets</a></div>
          </div>
        </div>
      </div>
      <!--
      <div class="flex-1 flex items-end">
        <img src="/WWSL22-TheLineup.png">
      </div>
      -->
    </div>
    <div
      class="
        copy
        px-8
        sm:px-32
        py-8
        pb-20
        flex flex-col
        sm:flex-row
        justify-between
        sm:items-center
      "
    >
      <div>
        <div class="pb-4">
          Copyrights © 2026 WinWin Staff Lottery
        </div>
        <div class="font-bold">
          <a href="mailto:customerservice@winwinstafflottery.ca">customerservice@winwinstafflottery.ca</a>
          <span class="font-normal"> | </span>
          <a href="tel:+18445946946">1 (844) 594-6946</a>
        </div>
      </div>
      <!-- <div class="pt-8 sm:pt-0">
				<span class="brand-icon"><i class="fas fa-rss"></i></span>
				<span class="brand-icon"><i class="fab fa-facebook-f"></i></span>
				<span class="brand-icon"><i class="fab fa-twitter"></i></span>
				<span class="brand-icon"><i class="fab fa-pinterest"></i></span>
				<span class="brand-icon"><i class="fab fa-youtube"></i></span>
			</div> -->
    </div>
  </div>
</template>
<script>
	export default {
		name: "WinWinFooter",
	};
</script>
<style scoped>
	.footer .bigger-font {
		font-size: 18px;
		cursor: default;
	}

	.footer .brand-icon {
		font-size: 15px;
		background-color: #555555;
		width: 15px;
		padding: 7.5px 13.12px;
		margin: 5px;
		border-radius: 3px;
		cursor: pointer;
		border: 1px solid #555555;
	}

	.footer .brand-icon:hover {
		color: #c1b598;
		border: 1px solid #000000;
		background-color: #000000;
	}

	.footer .copy {
		border-top: 1px solid #eeeeee;
		border-top-color: rgba(255, 255, 255, 0.1);
	}

  .columnfooter {
  float: left;
  width: 33.33%;
  padding: 10px;
}

.rowfooter:after {
  content: "";
  display: table;
  clear: both;
}

</style>
